import React from 'react'
import styled from 'styled-components'
import AddIcon from '@mui/icons-material/Add';
import { pBtn } from 'components/main.styled';

export default function CreateButton(props) {


  return (
    <CreateButtonContainer
        rightEnd={props.rightEnd}
        onClick={props.handler}
        >
        {
            props.customIcon ? (
                props.customIcon
            )
            :
            (
                <AddIcon />
            )
        }
        <span> {props.buttonText} </span>
    </CreateButtonContainer>
  )
}

const CreateButtonContainer = styled(pBtn)` 
    border: 1px solid white; 
    background-color: white;
    color: var(--lightThemeFontColor); 
    box-shadow: 0 0 10px #ccc; 
    margin-right: ${props => props.rightEnd ? "0px" : "15px"}; 

    &:hover{
        border: 1px solid var(--ltGreenButtonSolid);
        background-color: var(--ltGreenButtonSolid);
        color: white;

        svg{
            color: white;
        }
    }   
    svg{
        font-size: 17px;
        margin-right: 5px;
    }

    @media (max-width: 768px) {
        margin-bottom: 0px;

        span{
            font-size: 12px;
        }
    }

`
